import React from "react";
import FAQ from "../components/FAQ";
import SEO from "../components/SEO";
import { useSettings } from "../lib/settings";

const FAQPage = () => {
  const { settings } = useSettings();
  const faqItems = settings?.faq || [];
  const faqLd = faqItems.length
    ? {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqItems.map((it) => ({
          "@type": "Question",
          name: it.q,
          acceptedAnswer: { "@type": "Answer", text: it.a },
        })),
      }
    : null;
  return (
    <div className="pt-16">
      <SEO
        title="FAQ · Free Istanbul Tours"
        description="Frequently asked questions about our Istanbul tours: group sizes, cancellation policy, meeting points, payment, and what to bring."
        path="/faq"
        jsonLd={faqLd || undefined}
      />
      <FAQ />
    </div>
  );
};

export default FAQPage;
